/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendMessageDto } from '../../models/backend-message-dto';

export interface MonitoringComparisonsUpdateCalculationsCreate$Params {
  scenario_id: number;
}

export function monitoringComparisonsUpdateCalculationsCreate(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringComparisonsUpdateCalculationsCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendMessageDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringComparisonsUpdateCalculationsCreate.PATH, 'post');
  if (params) {
    rb.path('scenario_id', params.scenario_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendMessageDto>;
    }),
  );
}

monitoringComparisonsUpdateCalculationsCreate.PATH = '/api/monitoring/comparisons/update-calculations/{scenario_id}/';
